<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item>档案管理</el-breadcrumb-item>
		  <el-breadcrumb-item>windows数据查询</el-breadcrumb-item>
		</el-breadcrumb>

    <el-tabs v-model="formData.dataType" type="border-card" @tab-click="handleClick">
      <el-form inline label-width="80" @submit.native.prevent>
        <el-form-item label="搜索:">
          <el-input type="请输入关键词" v-model="formData.term" size="small" placeholder="请输入关键词"  @keyup.enter.native="getData"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" @click="getData">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-tab-pane label="pob_meter" name="pob_meter">
        <el-table size="small" border :data="pob_meterDats"  v-loading="loading"  :header-cell-style="this.$store.state.headerCss">
        	<el-table-column type="index" width="50"></el-table-column>
        	<el-table-column label="pointid"  prop="pointid"  ></el-table-column>
        	<el-table-column label="disc" prop="disc"    ></el-table-column>

        	<el-table-column label="commaddress" prop="commaddress"   ></el-table-column>
        	<el-table-column label="type" prop="type"    ></el-table-column>
          <el-table-column label="createtime" prop="createtime"    ></el-table-column>
        	<el-table-column label="操作" align="center" width="120" >
        		<template slot-scope="scope">
        			<el-button size="mini" type="danger" @click="delInfo(scope.row)">删除</el-button>
        		</template>
        	</el-table-column>
        </el-table>


      </el-tab-pane>
      <el-tab-pane label="pob_point" name="pob_point">
        <el-table size="small" border :data="pob_pointDatas"  v-loading="loading"  :header-cell-style="this.$store.state.headerCss">
        	<el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="pointid" prop="pointid"   ></el-table-column>
        	<el-table-column label="commaddress"  prop="commaddress"  ></el-table-column>
        	<el-table-column label="rtuAddress" prop="rtuAddress"    ></el-table-column>
          <el-table-column label="numberid" prop="numberid"    ></el-table-column>
        	<el-table-column label="rtuid" prop="rtuid"    ></el-table-column>
        	<el-table-column label="操作" align="center" width="120" >
        		<template slot-scope="scope">
        			<el-button size="mini"  type="danger" @click="delInfo(scope.row)">删除</el-button>
        		</template>
        	</el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="pob_rtu" name="pob_rtu">
        <el-table size="small" border :data="pob_rtuDatas"  v-loading="loading"  :header-cell-style="this.$store.state.headerCss">
        	<el-table-column type="index" width="50"></el-table-column>

        	<el-table-column label="commaddress"  prop="commaddress"  ></el-table-column>
        	<el-table-column label="disc" prop="disc"    ></el-table-column>
          <el-table-column label="createtime" prop="createtime"   ></el-table-column>
        	<el-table-column label="ip" prop="ip" ></el-table-column>

          <el-table-column label="protocolid" prop="protocolid" ></el-table-column>
          <el-table-column label="readschemeid" prop="readschemeid" ></el-table-column>
          <el-table-column label="regionid" prop="regionid" ></el-table-column>
          <el-table-column label="rtuid" prop="rtuid" ></el-table-column>
          <el-table-column label="rtustatus" prop="rtustatus" ></el-table-column>
          <el-table-column label="type" prop="type" ></el-table-column>
        	<el-table-column label="操作" align="center" width="120" >
        		<template slot-scope="scope">
        			<el-button size="mini" type="danger" @click="delInfo(scope.row)">删除</el-button>
        		</template>
        	</el-table-column>
        </el-table>
      </el-tab-pane>

    </el-tabs>
    <Pagination v-if='showPage' v-bind:child-msg="formData" @callFather="callFather"></Pagination>

	</div>
</template>

<script>
  import {getWindowsData,deleteWindowsDataById} from '../../api/dataMG.js'
  import Pagination from '../../components/Pagination'
	export default{
     data() {
      return {


        pob_meterDats:[],
        pob_pointDatas:[],
        pob_rtuDatas:[],
        showPage:true,
        loading:false,
        formData:{
          dataType:'pob_meter',
          currentPage: 1,
          pageSize: 10,
          total: 0,
          term:"",
        }
      };
    },
    created(){
      this.getData()
    },
    components: {
      Pagination,

    },
    methods:{
      getData(){
        this.pob_meterDats = []
        this.pob_pointDatas = []
        this.pob_rtuDatas = []
        this.loading = true
        getWindowsData(this.formData).then(res=>{
          this.loading = false

          if(res.status == 1){
            if(this.formData.dataType == 'pob_meter'){

              this.pob_meterDats = res.data.data
            }else if(this.formData.dataType == 'pob_point'){
              this.pob_pointDatas = res.data.data
            }else{
              this.pob_rtuDatas = res.data.data
            }
            this.formData.total = res.data.totalCount


            console.log(this.pob_meterDats)
          }

        })
      },
      callFather(parm) {
        this.formData.currentPage = parm.currentPage
        this.formData.pageSize = parm.pageSize
        this.getData()
      },
      delInfo(row){

        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let id = ''
          if(this.formData.dataType == 'pob_meter' || this.formData.dataType == 'pob_point'){
            id = row.pointid
          }else {
            id = row.rtuid
          }

          let param = {
            id:id,
            dataType:this.formData.dataType
          }
          deleteWindowsDataById(param).then(res => {
            if(res.status == 1){
              this.$message.success('删除成功')
              this.getData()
            }else{
              this.$message.error(res.msg)
            }
          })
        })
        .catch(()=>{

        })


      },
      handleClick(){
        this.formData.term = ''
        this.formData.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(()=>{
          this.showPage = true
        })
      }
    }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/archives/windowsData.vue